import { type ReactElement } from 'react'

import { CartIntermediateProductAddToCartErrorMessage } from './CartIntermediateProductAddToCartErrorMessage'
import { CartIntermediateProductAddToCartSuccessMessage } from './CartIntermediateProductAddToCartSuccessMessage'

export const CartIntermediateMessages = ({
  isProductSuccessfullyAdded,
}: {
  isProductSuccessfullyAdded: boolean
}): ReactElement => {
  const renderSuccessMessage = (): ReactElement => (
    <CartIntermediateProductAddToCartSuccessMessage />
  )
  const renderErrorMessage = (): ReactElement => (
    <CartIntermediateProductAddToCartErrorMessage />
  )

  return isProductSuccessfullyAdded
    ? renderSuccessMessage()
    : renderErrorMessage()
}
